import { Group, Stack, StackProps, Text } from '@mantine/core';
import { HiX } from 'react-icons/hi';
import ResultsChat from '@/layouts/ResultsChat/ResultsChat.tsx';
import StyledButton from '@/components/StyledButton/StyledButton.tsx';
import { useViewChatSidebar } from '@/layouts/AutomationPageWrapper/hooks/useViewChatSidebar.ts';
import AppIcon from '@/components/AppIcon.tsx';
import { HiOutlineChatBubbleLeftRight } from 'react-icons/hi2';

const ResultsChatSidebar = ({ ...props }: StackProps) => {
  const { setShowChat } = useViewChatSidebar();

  return (
    <Stack {...props} w={'100%'} h={'100%'}>
      <Group
        justify="space-between"
        align="center"
        px="sm"
        style={{ borderBottom: '1px solid #e0e0e0' }}
        h={46}
        mih={46}
      >
        <Stack gap={'1px'}>
          <Group gap={'6px'}>
            <AppIcon Icon={HiOutlineChatBubbleLeftRight} size={16} />
            <Text fw={500}>Assistant</Text>
          </Group>
          <Text fw={400} size={'11px'} c={'#9E9E9E'}>
            Ask questions about the results
          </Text>
        </Stack>
        <StyledButton
          variant={'subtleIcon'}
          size={'sm'}
          aria-label="Close assistant"
          onClick={() => setShowChat(false)}
          styles={{
            root: {
              padding: '5px',
              width: '25px',
              height: '25px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            },
          }}
        >
          <HiX />
        </StyledButton>
      </Group>
      <ResultsChat />
    </Stack>
  );
};

export default ResultsChatSidebar;
